/* Onglet Livraison des fiches produit : le menu pays affiche la zone choisie.
   Sans JavaScript, la zone de la visiteuse reste affichée (rendu Liquid). */
if (!customElements.get('livraison-zones')) {
  customElements.define(
    'livraison-zones',
    class LivraisonZones extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        if (!this.select) return;
        this.select.addEventListener('change', () => this.afficher(this.select.value));
        /* Retour arrière : le navigateur peut restaurer une autre valeur du menu. */
        this.afficher(this.select.value);
      }

      afficher(zone) {
        this.querySelectorAll('[data-zone]').forEach((panneau) => {
          panneau.hidden = panneau.dataset.zone !== zone;
        });
      }
    }
  );
}
